module.exports = __webpack_public_path__ + "fonts/Inter-Regular.a51fb83e.woff";